import React, { useState, useEffect } from "react";
import "./style.css";
import Table from "react-bootstrap/Table";
import API from "../../utils/API";

function UmbrellaPolicyUpdateForm({ policyData, agents }) {
  const [formData, setFormData] = useState({
    policyNumber: "",
    carrier: "",
    effectiveDate: "",
    clientFirstName: "",
    clientLastName: "",
    clientID: "",
    liability: "",
    premium: "",
    mainAgent: "",
    mainAgentSplit: "",
    refAgentOne: "",
    refAgentOneSplit: "",
    refAgentTwo: "",
    refAgentTwoSplit: "",
    refAgentThree: "",
    refAgentThreeSplit: "",
    refAgentFour: "",
    refAgentFourSplit: "",
    declaration: ""
  });

  useEffect(() => {
    console.log("Umbrella Update Policy Form Component Launched with props:");
    console.log(policyData);

    setFormData((prev) => ({
      ...prev,
      policyNumber: policyData.policyNumber,
      carrier: policyData.carrier,
      effectiveDate: policyData.effectiveDate,
      clientFirstName: policyData.clientFirstName,
      clientLastName: policyData.clientLastName,
      clientID: policyData.clientID,
      liability: policyData.liability,
      premium: policyData.premium,
      mainAgent: policyData.mainAgent,
      mainAgentSplit: policyData.mainAgentSplit,
      refAgentOne: policyData.refAgentOne,
      refAgentOneSplit: policyData.refAgentOneSplit,
      refAgentTwo: policyData.refAgentTwo,
      refAgentTwoSplit: policyData.refAgentTwoSplit,
      refAgentThree: policyData.refAgentThree,
      refAgentThreeSplit: policyData.refAgentThreeSplit,
      refAgentFour: policyData.refAgentFour,
      refAgentFourSplit: policyData.refAgentFourSplit,
      declaration: policyData.url
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePolicyUpdate = (event) => {
    event.preventDefault();
    console.log(formData);

    const umbrellaInformation = {
      policyNumber: formData.policyNumber,
      carrier: formData.carrier,
      effectiveDate: formData.effectiveDate,
      clientFirstName: formData.clientFirstName,
      clientLastName: formData.clientLastName,
      clientID: formData.clientID,
      liability: formData.liability,
      premium: formData.premium,
      mainAgent: formData.mainAgent,
      mainAgentSplit: formData.mainAgentSplit,
      refAgentOne: formData.refAgentOne,
      refAgentOneSplit: formData.refAgentOneSplit,
      refAgentTwo: formData.refAgentTwo,
      refAgentTwoSplit: formData.refAgentTwoSplit,
      refAgentThree: formData.refAgentThree,
      refAgentThreeSplit: formData.refAgentThreeSplit,
      refAgentFour: formData.refAgentFour,
      refAgentFourSplit: formData.refAgentFourSplit,
      declaration: formData.declaration
    };

    API.updateUmbrellaPolicy(policyData._id, umbrellaInformation)
      .then((_res) => {
        console.log("Updated Umbrella Policy");
        console.log(_res.data);
        alert("Updated Umbrella Policy");
      })
      .catch((_err) => console.log(_err));
  };

  return (
    <div>
      <div className="card">
        <h5 style={{ textAlign: "center" }}>Update an Umbrella Policy</h5>
        <div className="card-body">
          <form>
            <Table bordered hover>
              <tbody>
                <tr>
                  <td>Question</td>
                  <td>Input</td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Policy Number
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.policyNumber}
                      onChange={handleInputChange}
                      name="policyNumber"
                      placeholder="Policy Number"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Carrier
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.carrier}
                      onChange={handleInputChange}
                      name="carrier"
                      placeholder="Carrier"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client First Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.clientFirstName}
                      onChange={handleInputChange}
                      name="clientFirstName"
                      placeholder="Client First Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Client Last Name
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.clientLastName}
                      onChange={handleInputChange}
                      name="clientLastName"
                      placeholder="Client Last Name"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Excess Liability
                  </td>
                  <td>
                    <input
                      type="text"
                      value={formData.liability}
                      onChange={handleInputChange}
                      name="liability"
                      placeholder="Personal Liability Limits"
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Premium
                  </td>
                  <td>
                    <input
                      type="number"
                      value={formData.premium}
                      onChange={handleInputChange}
                      name="premium"
                      placeholder="Premium"
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
            <Table>
              <tbody>
                <tr>
                  <th>Item Name</th>
                  <th>Agent</th>
                  <th>Split</th>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Main Agent
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.mainAgent}
                          onChange={handleInputChange}
                          name="mainAgent"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.mainAgent ? (
                      <input
                        type="number"
                        value={formData.mainAgentSplit}
                        name="mainAgentSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #1
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentOne}
                          onChange={handleInputChange}
                          name="refAgentOne"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentOne ? (
                      <input
                        type="number"
                        value={formData.refAgentOneSplit}
                        name="refAgentOneSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #2
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentTwo}
                          onChange={handleInputChange}
                          name="refAgentTwo"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentTwo ? (
                      <input
                        type="number"
                        value={formData.refAgentTwoSplit}
                        name="refAgentTwoSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #3
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentThree}
                          onChange={handleInputChange}
                          name="refAgentThree"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentThree ? (
                      <input
                        type="number"
                        value={formData.refAgentThreeSplit}
                        name="refAgentThreeSplit"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      textAlign: "center",
                      backgroundColor: "black",
                      color: "white",
                      fontWeight: "bold"
                    }}
                  >
                    Referral Agent #4
                  </td>
                  <td>
                    {agents ? (
                      <div>
                        <select
                          id="protegeDropMenu"
                          value={formData.refAgentFour}
                          onChange={handleInputChange}
                          name="refAgentFour"
                        >
                          <option value="">--Select an Agent--</option>
                          {agents.map((agent) => (
                            <option key={agent._id} value={agent._id}>
                              {agent.firstName} {agent.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      <div>No agents yet</div>
                    )}
                  </td>
                  <td>
                    {formData.refAgentFour ? (
                      <input
                        type="number"
                        value={formData.refAgentSplitFour}
                        name="refAgentSplitFour"
                        onChange={handleInputChange}
                      />
                    ) : null}
                  </td>
                </tr>
              </tbody>
            </Table>
            <div style={{ textAlign: "center" }}>
              <button className="btn-success btn-sm btn" onClick={(e) => handlePolicyUpdate(e)}>
                Update Policy
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default UmbrellaPolicyUpdateForm;
